/**
 * Created by piotr.pozniak@thebeaverhead.com on 03/02/2023
 */

import React from "react";
import { getReferralCoupon } from "../../../../actions/plans";

/**
 * DiscountHeader component displays a header with a success message
 * @param {Object} discount
 * @returns {React.JSX.Element|null}
 * @constructor
 */
const DiscountHeader = ({ discount }) => {
  const coupon = getReferralCoupon();
  if (!coupon || !discount) {
    return null;
  }

  const duration =
    discount.duration === "once" ? "first payment" : "each payment";

  return (
    <div className={"row"}>
      <div className={"col-12"}>
        <div className={"d-flex justify-content-center alert alert-success"}>
          <div>
            Congratulations: Affiliate Discount Found!{" "}
            <strong>{discount.name}</strong>! {duration}.
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountHeader;
